import { Model as s } from "../../../model.js";
class e extends s {
  constructor(t) {
    super(), this.id = t.id, this.code = t.code, this.loyaltyProgramme = t.loyaltyProgramme, this.startDate = t.startDate, this.endDate = t.endDate, this.status = t.status, this.name = t.name, this.audience = t.audience, this.configuration = t.configuration;
  }
}
export {
  e as TierModel
};
//# sourceMappingURL=tier.model.js.map
